import { useEffect } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Form, Modal } from 'react-bootstrap';
import { DashboardApi } from 'apis/DashboardApi';
import { useSuperState } from 'hooks';

const EMAIL_CLAIM = 'http://schemas.gmetrix.net/claims/AdminEmailCommunicationOptIn';

export const NewsAndUpdatesDialog = props => {

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        optIn: true,
        saving: false,
        visible: false
    });
    const { optIn, saving, visible } = state;

    const hide = () => setState({ visible: false });

    const fetchClaims = async () => {

        try {

            const missing = await DashboardApi.GetMissingClaims();
            const needsEmailOptIn = missing.some(c => c === EMAIL_CLAIM);

            if (!needsEmailOptIn) return;

            setState({ visible: true });

        } catch {

            // Silently fail — don't block the dashboard
        }

    };

    const handleConfirm = async () => {

        setState({ saving: true });

        try {

            await DashboardApi.UpdateClaims(optIn);
            setState({ saving: false, visible: false });

        } catch {

            setState({ saving: false });

        }

    };

    useEffect(() => {

        fetchClaims();

    }, []);

    return (
        <Modal centered onHide={hide} show={visible}>
            <Modal.Header>
                <Modal.Title>
                    <FormattedMessage defaultMessage="Sign Up for News and Updates" id="sign_up_for_news_and_updates.73d1884c" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <FormattedMessage defaultMessage="Get the latest updates about new features, product releases, and important information delivered straight to your inbox." id="get_the_latest_updates_about_new_feature.63fb29fe" />
                </p>

                <Form.Check
                    checked={optIn}
                    className={'d-inline-flex gap-1'}
                    id="claims-email-optin"
                    label={formatMessage({ id: 'yes_i_would_like_to_receive_email_messag.73f8df93', defaultMessage: 'Yes, I would like to receive email messaging from GMetrix' })}
                    onChange={e => setState({ optIn: e.target.checked })}
                    type="checkbox"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={saving} onClick={handleConfirm} variant="primary">
                    {saving ? <FormattedMessage defaultMessage="Saving..." id="saving.c916139e" /> : <FormattedMessage defaultMessage="Confirm" id="confirm.297ab8f4" />}
                </Button>
            </Modal.Footer>
        </Modal>
    );

};
